import {FormInstance} from 'antd/es/form';
import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {IValidationController} from 'components/editable-table/model/types';
import {loadMetadata, selectMetadata, ITableEntityMeta} from 'entities/metadata';
import {TEntity} from 'modules/data';
import {loadAdditionalFormData, loadEditableData} from 'modules/data/data-actions';
import {selectEditableTableEntityData} from 'modules/data/data-selectors';
import {EEntityType} from 'shared/constants/entities';
import {useAppSelector} from 'store/config/hooks';
import {selectModalData} from 'store/slices/modals-slice';

export const useEditableTableActions = (
    entityName: string,
) => {
    const dispatch = useDispatch();
    const currentLocation = useLocation<History>();
    const [initData, setInitData] = useState<TEntity[]>([]);
    const [form, setForm] = useState<FormInstance>();
    const [validation, setValidation] = useState<IValidationController>();
    const tableData = useAppSelector(selectEditableTableEntityData(entityName))?.rows;

    const modalData = useAppSelector(selectModalData);
    const metaData: ITableEntityMeta = useAppSelector(selectMetadata(
        entityName,
        EEntityType.EDITABLE_TABLE,
    ));
    const modalTitle = metaData?.title;
    const disabledPagination = metaData?.disabledPagination;
    const tableDataOptions = {
        useContext: metaData?.useContext,
        useSearch: metaData?.isSearchable,
        disabledPagination: metaData?.disabledPagination,
        paramsToBeConverted: {...modalData.modalParameters},
    };
    useEffect(() => {
        const shouldLoadMetadata = !metaData;
        const referenceUrl = metaData?.additionalOptions?.optionsField.referenceUrl;
        if (shouldLoadMetadata) {
            dispatch(loadMetadata(entityName, EEntityType.EDITABLE_TABLE));
            return;
        }
        if (metaData) {
            const url = modalData.modalParameters?.referenceUrl;
            dispatch(loadEditableData(entityName, tableDataOptions, url));
        }
        if (referenceUrl) {
            dispatch(loadAdditionalFormData(entityName, referenceUrl));
        }
    }, [metaData]);

    const handleEdit = (tableRow: TEntity) => {
        const index = initData?.findIndex(element => element.id === tableRow?.id);
        if (index !== -1) {
            initData.splice(index, 1);
            setInitData([...initData, tableRow]);
            return;
        }
        setInitData([...initData, tableRow]);
    };
    return {
        width: metaData?.width,
        modalTitle,
        initData,
        form,
        setForm,
        validation,
        setValidation,
        tableData,
        handleEdit,
        currentLocation,
        disabledPagination,
        actions: metaData?.actions,
    };
};
